module.exports = {"410472001":"湖滨路街道","410472101":"滍阳镇","410472401":"滨湖管委会","410472402":"应滨管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410472.json
// module id = 1563
// module chunks = 0